import { toast } from 'sonner';
import { useApiQuery } from '@/hooks/useApiQuery';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiDelete, apiGet, apiPost, operationsClient } from '@/lib/api';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type {
  CreatePartnerApiKeyDto,
  CreatedPartnerApiKey,
  PartnerApiKey,
} from '@/types/partnerApiKey';

export function usePartnerApiKeys() {
  return useApiQuery<PartnerApiKey[]>({
    queryKey: settingsKeys.partnerApiKeys(),
    queryFn: () => apiGet<PartnerApiKey[]>(operationsClient, settingsEndpoints.partnerApiKeys()),
    showErrorToast: false,
  });
}

export const useCreatePartnerApiKey = createMutationHook<
  CreatedPartnerApiKey,
  CreatePartnerApiKeyDto
>({
  mutationFn: (dto) =>
    apiPost<CreatedPartnerApiKey, CreatePartnerApiKeyDto>(
      operationsClient,
      settingsEndpoints.partnerApiKeys(),
      dto,
    ),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.partnerApiKeys() });
    toast.success('API key created');
  },
});

export const useRevokePartnerApiKey = createMutationHook<void, string>({
  mutationFn: (id) => apiDelete<void>(operationsClient, settingsEndpoints.partnerApiKey(id)),
  onSuccess: (_data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: settingsKeys.partnerApiKeys() });
    toast.success('API key revoked');
  },
});
